interface GettextWindow extends Window {
  gettext: Gettext;
}

declare let window: GettextWindow;

type Gettext = (id: string) => string;

let gettext: Gettext;

if (window.gettext) {
  gettext = window.gettext;
} else {
  gettext = (id) => {
    return id;
  };
}

export default gettext;
